import { ViewResponseModel } from "lib/types/views/ViewResponseModel";
import { ViewModel } from "lib/types/views/ViewModel";

export function mapViewFromResponse(r: ViewResponseModel): ViewModel {
  return {
    ...r,
    assetVersionIds: r.assetVersionIds ?? [],
    cameraPosition: r.cameraPosition ?? [],
    createdOn: (r.createdOn && new Date(r.createdOn)) || null,
  };
}
